import { render, staticRenderFns } from "./ExternalLinkModal.vue?vue&type=template&id=52d95b32&scoped=true"
import script from "./ExternalLinkModal.vue?vue&type=script&lang=ts"
export * from "./ExternalLinkModal.vue?vue&type=script&lang=ts"
import style0 from "./ExternalLinkModal.vue?vue&type=style&index=0&id=52d95b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d95b32",
  null
  
)

export default component.exports